import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const InvertedCheckSVG = styled(Icon).attrs({ viewBox: '0 0 300 300' })``;

const InvertedCheck = ({ color = navy, ...props }) => (
    <InvertedCheckSVG
        data-test="icon-inverted-check"
        {...props}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M283.7 82.8L154.5 208.6h-45.4V90.4h34.7v80.8S262.9 55.3 264.4 53.8C237 21.2 195.9.4 150 .4 67.4.4.2 67.6.2 150.2.2 232.8 67.4 300 150 300s149.8-67.2 149.8-149.8c0-24.2-5.8-47.1-16.1-67.4z"
            fill={color}
        />
    </InvertedCheckSVG>
);

export {
    InvertedCheck as default,
    InvertedCheck,
};
